import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { fadeOut } from '../router.animations';
import { Router, ActivatedRoute } from '@angular/router';
import { LayoutService } from '../layout.service';
import { SplashService } from '../splash.service';
import { BreakpointsService } from '../breakpoints.service';
// import { Subscription } from 'rxjs/Subscription';
import * as imagesLoaded from 'imagesloaded';
import { appConfig } from './../app.config';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { random } from 'lodash';

@Component({
  selector: 'app-splash-page',
  templateUrl: './splash-page.component.html',
  styleUrls: ['./splash-page.component.scss'],
  host: {
    '(click)': 'close($event)',
    '[@fadeOut]': ''
  },
  animations: [
    fadeOut,
    trigger('fadeIn', [
      state('hidden', style({
        opacity: '0',
        visibility: 'hidden'
      })),
      state('visible',   style({
        opacity: '1',
        visibility: 'visible'
      })),
      transition('hidden => visible', animate('250ms ease-in')),
      transition('visible => hidden', animate('250ms ease-in'))
    ])
  ]
})
export class SplashPageComponent implements OnInit {
  @ViewChild('bgDesktop') bgDesktopRef: ElementRef;
  @ViewChild('bgMobile') bgMobileRef: ElementRef;
  backgroundImageSrc: any;
  video: any;
  showBGImage: boolean = false;
  titleImage: any;
  showTitle: boolean = false;
  public imageSrcBase = appConfig.imageUrl;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public SplashService: SplashService,
    private LayoutService: LayoutService,
    private BreakpointsService: BreakpointsService
  ) {
    this.titleImage = this.SplashService.titleImage;

    const backgroundImages = this.SplashService.backgroundImages;
    const randomIndex = random(0, backgroundImages.length - 1);
    const backgroundImage = backgroundImages[randomIndex];
    if (backgroundImages.length === 0) {
      this.backgroundImageSrc = '';
    } else if (this.isHiResScreen()) {
      this.backgroundImageSrc = {
        desktop: backgroundImage.image.original,
        mobile: backgroundImage.image.large_retina
      };
    } else {
      this.backgroundImageSrc = {
        desktop: backgroundImage.image.original,
        mobile: backgroundImage.image.large 
      };
    }
  }

  ngOnInit() {
    setTimeout(() => {
      imagesLoaded(this.bgDesktopRef.nativeElement, { background: true }, () => {
        setTimeout(() => {
          this.showBGImage = true;

          setTimeout(() => {
            this.showTitle = true;
          }, 1000);
        }, 750);
      });
      
      imagesLoaded(this.bgMobileRef.nativeElement, { background: true }, () => {
        setTimeout(() => {
          this.showBGImage = true;

          setTimeout(() => {
            this.showTitle = true;
          }, 1000);
        }, 750);
      });
    });
  }

  // xoxo duped
  isHiResScreen() {
    // starts with default value for modern browsers
    var dpr = window.devicePixelRatio ||

    // fallback for IE
    (window.screen.deviceXDPI / window.screen.logicalXDPI) ||

    // default value
    1;

    return !!(dpr > 1);
  }

  close($event) {
    this.showTitle = false;
    setTimeout(() => {
      this.LayoutService.showSplashscreen = false;
    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/app/splash-page/splash-page.component.ts